export const CELL_SIZE = 64;
